







import { defineComponent } from 'vue-demi';
import { i18n } from '../../../i18n';
import { windowHelper } from '@tencent/ppd-base-libs';
import { getCurBusinessName } from '../../../components/activity-module/hook';

export default defineComponent({
  name: 'MallTitle',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  setup(props, context) {
    function handleClick() {
      const bizName = getCurBusinessName();
      windowHelper.redirect(`//prom.wechatpay.com.hk/discount-center/coupon_home.shtml?ADTAG=${bizName}_wecoupons_mall&page=displaycouponlist`, 300);
    }

    return {
      i18n,
      handleClick,
    };
  },
});
